import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import { store } from '../Store'
// import Home from '@/components/Home'
import Manage from '@/components/Manage'
import Search from '@/components/Search'
// import ServicesSearch from '@/components/ServicesSearch'
import StartStore from '@/components/StartStore'
import Benefits from '@/components/Benefits'
import Restaurants from '@/components/Restaurants'
import About from '@/components/About'
import TermsOfUse from '@/components/TermsOfUse'
import PrivacyPolicy from '@/components/PrivacyPolicy'
// import StoreSidebar from '@/components/store/StoreSidebar'
import StoreNavbar from '@/components/store/StoreNavbar'
// import Header from '@/components/store/Header'
import StoreCart from '@/components/store/Cart'
import StoreCategories from '@/components/store/Categories'
import StoreOffers from '@/components/store/Offers'
import StoreProducts from '@/components/store/Products'
import StoreProductDetails from '@/components/store/ProductDetails'
import StoreHome from '@/components/store/StoreHome'
// import StoreServices from '@/components/store/StoreServices'
import StoreContact from '@/components/store/Contact'
import StoreAbout from '@/components/store/About'
// import PSResults from '@/components/store/PSResults'


import UserSignup from '@/components/user/UserSignup'
import Signin from '@/components/user/Signin'
import CheckEmail from '@/components/user/CheckEmail'
import MyAccount from '@/components/user/MyAccount'

import RegShop from '@/components/user/RegShop'
import AllProducts from '@/components/admin/AllProducts'
import Categories from '@/components/admin/Categories'
import EditCommonProduct from '@/components/admin/EditCommonProduct'
import EditMobiles from '@/components/admin/EditMobiles'
import EditVehicles from '@/components/admin/EditVehicles'
import Offers from '@/components/admin/Offers'
import Items from '@/components/admin/Items'
import AllOffers from '@/components/admin/AllOffers'
import AllItems from '@/components/admin/AllItems'
import Dashboard from '@/components/admin/Dashboard'
// import Admin from '@/components/admin/Admin'
import Payment from '@/components/admin/Payment'
import Orders from '@/components/admin/Orders'
import AdminGallery from '@/components/admin/Gallery'
import MyShopin from '@/components/admin/MyShopin'
// import AddUser from '@/components/admin/AddUser'
import Customers from '@/components/admin/Customers'
// import Sidebar from '@/components/admin/Sidebar'
import AdminHome from '@/components/admin/AdminHome'
import AdminAbout from '@/components/admin/AdminAbout'
import AdminContact from '@/components/admin/AdminContact'
import AdminSetting from '@/components/admin/AdminSetting'
import Mobiles from '@/components/admin/Mobiles'
import Vehicles from '@/components/admin/Vehicles'

// import RegServices from '@/components/user/RegServices'
// import Services from '@/components/admin-services/Services'
// import Gallery from '@/components/admin-services/Gallery'
// import AllServices from '@/components/admin-services/AllServices'
// import DashboardServices from '@/components/admin-services/Dashboard'
// import AdminServices from '@/components/admin-services/Admin'
// import MyShopinServices from '@/components/admin-services/MyShopin'
// import AdminHomeServices from '@/components/admin-services/AdminHome'
// import AdminAboutServices from '@/components/admin-services/AdminAbout'
// import AdminContactServices from '@/components/admin-services/AdminContact'


import AdminView from '@/components/admin/AdminView'
import CreateInvoice from '@/components/admin/CreateInvoice'
import CreateBarcode from '@/components/admin/CreateBarcode'
import InvoiceList from '@/components/admin/InvoiceList'
import ManageCategories from '@/components/admin/ManageCategories'
import Analytics from '@/components/admin/Analytics'
import Returns from '@/components/admin/Returns'
import ReturnsGRN from '@/components/admin/ReturnsGRN'
import Users from '@/components/admin/Users'
import VerifyUser from '@/components/admin/VerifyUser'
import Setting from '@/components/admin/Setting'
import StoreLocations from '@/components/admin/StoreLocations'
import Suppliers from '@/components/admin/Suppliers'
import CashFlow from '@/components/admin/CashFlow'
import CashFlowList from '@/components/admin/CashFlowList'
import Expenses from '@/components/admin/Expenses'
import ExpenseCategories from '@/components/admin/ExpenseCategories'
import Quotations from '@/components/admin/Quotations'
import PurchaseOrders from '@/components/admin/PurchaseOrders'
import KOT from '@/components/admin/KOT'
import StockSummary from '@/components/admin/StockSummary'
import JobNotes from '@/components/admin/JobNotes'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/app.js',
      name: 'app',
      component: StartStore,
      meta: {
        title: 'Eshops.lk - Its all about success of your business.',
      }
    },
    {
      path: '/',
      name: 'home',
      component: StartStore,
      meta: {
        title: 'Eshops.lk - Its all about success of your business.',
      }
    },
    {
      path: '/index.html',
      component: StartStore,
      meta: {
        title: 'Eshops.lk - Its all about success of your business.',
      }
    }, // Fix for PWA at /index.html
    {
      path: '/benefits',
      name: 'benefits',
      component: Benefits,
      meta: {
        title: 'Eshops.lk - Explore features and benefits',
      }
    },
    {
      path: '/for-restaurants',
      name: 'restaurants',
      component: Restaurants,
      meta: {
        title: 'Eshops.lk - Special benefits for restaurants & cafes',
      }
    },
    // {
    //   path: '/adminview',
    //   name: 'home',
    //   component: AdminView,
    //   meta: {
    //     title: 'Eshops.lk - Start Your Online Store | Shop Online in Your City',
    //   }
    // },

    // {
    //   path: '/search',
    //   name: 'search',
    //   component: Search,
    //   meta: {
    //     title: 'Search - Stores',
    //   }
    // },
    // {
    //   path: '/services-search',
    //   name: 'servicessearch',
    //   component: ServicesSearch,
    //   meta: {
    //     title: 'Search - Services',
    //   }
    // },
    // {
    //   path: '/productssearch',
    //   name: 'psresults',
    //   component: PSResults
    // },
    {
      path: '/',
      name: 'startstore',
      component: StartStore,
      meta: {
        title: 'eshops.lk - Start Your Online Store Now',
      }
    },
    {
      path: '/manage',
      name: 'manage',
      component: Manage,
      meta: {
        requiresAuth: true,
        title: 'Manage',
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        title: 'About Us',
      }
    },
    {
      path: '/termsofuse',
      name: 'termsofuse',
      component: TermsOfUse,
      meta: {
        title: 'Terms Of Use',
      }
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      component: PrivacyPolicy,
      meta: {
        title: 'Privacy Policy',
      }
    },
    // {
    //   path: '/services/:pageid',
    //   name: 'storeservices',
    //   component: StoreServices,
    //   meta: {
    //     title: 'Services',
    //   }
    // },

    {
      path: '/stores/:storename/',
      name: 'storehome',
      component: StoreHome,
      meta: {
        title: 'Store Home',
      },
      children: [
        {
          path: 'contact',
          name: 'storecontact',
          component: StoreContact,
          meta: {
            title: 'Store Contact',
          }
        },
        {
          path: 'about',
          name: 'storeabout',
          component: StoreAbout,
          meta: {
            title: 'Store About',
          }
        },
        {
          path: 'cart',
          name: 'storecart',
          component: StoreCart,
          meta: {
            title: 'Store Cart',
          }
        },
        {
          path: 'categories',
          name: 'storecategories',
          component: StoreCategories,
          meta: {
            title: 'Store Categories',
          }
        },
        {
          path: 'offers',
          name: 'storeoffers',
          component: StoreOffers,
          meta: {
            title: 'Store Offers',
          }
        },
        {
          path: 'categories/:cat',
          name: 'storeproducts',
          component: StoreProducts,
          meta: {
            title: 'Store Products',
          }
        },
        {
          path: 'productdetails/:id',
          name: 'storeproductdetails',
          component: StoreProductDetails,
          meta: {
            title: 'Store Product Details',
          }
        },
      ]
    },

    {
      path: '/usersignup',
      name: 'usersignup',
      component: UserSignup,
      meta: {
        requiresGuest: true,
        title: 'Sign up'
      }
    },
    {
      path: '/signin',
      name: 'signin',
      component: Signin,
      meta: {
        requiresGuest: true,
        title: 'Sign in'
      }

    },
    {
      path: '/myaccount',
      name: 'myaccount',
      component: MyAccount,
      meta: {
        requiresAuth: true,
        title: 'My Account',
      }


    },
    {
      path: '/registration/:plan',
      name: 'regshop',
      component: RegShop,
      meta: {
        // only remove this requiredAuth to enable link
        requiresAuth: false,
        title: 'Register Store'
      }

    },
    // {
    //   path: '/registration-starter-plan',
    //   name: 'regservices',
    //   component: RegServices,
    //   meta: {
    //     title: 'Register Store/Service'
    //   }

    // },
    {
      path: '/verifyemail',
      name: 'checkemail',
      component: CheckEmail,
      meta: {

        title: 'Verify Your Email'
      }

    },
    {
      path: '/admin/',
      name: 'admin',
      component: AdminView,
      // path: 'admin',
      // name: 'admin',
      // component: Sidebar,
      meta: {
        requiresAuth: true,
        title: 'Admin'
      },
      children: [
        // {
        //   path: 'sidebar',
        //   name: 'sidebar',
        //   component: Sidebar
        // },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: {
            requiresAuth: true,
            title: 'Admin Dashboard'
          },
        },
        {
          path: 'adminhome',
          name: 'adminhome',
          component: AdminHome,
          meta: {
            requiresAuth: true,
            title: 'Admin Home Page'
          },
        },
        {
          path: 'adminabout',
          name: 'adminabout',
          component: AdminAbout,
          meta: {
            requiresAuth: true,
            title: 'Admin About Page'
          },
        },
        {
          path: 'admincontact',
          name: 'admincontact',
          component: AdminContact,
          meta: {
            requiresAuth: true,
            title: 'Admin Contact Page'
          },
        },
        {
          path: 'admin-setting',
          name: 'adminsetting',
          component: AdminSetting,
          meta: {
            requiresAuth: true,
            title: 'Setting'
          },
        },
        {
          path: 'setting',
          name: 'setting',
          component: Setting,
          meta: {
            requiresAuth: true,
            title: 'Setting'
          },
        },
        {
          path: 'gallery',
          name: 'admingallery',
          component: AdminGallery,
          meta: {
            requiresAuth: true,
            title: 'Admin Gallery'
          }
        },
        {
          path: 'stock-summary',
          name: 'stockSummary',
          component: StockSummary,
          meta: {
            requiresAuth: true,
            title: 'Stock Summary'
          }
        },
        // {
        //   path: 'add-customer',
        //   name: 'addcustomer',
        //   component: AddUser,
        //   meta: {
        //     requiresAuth: true,
        //     title: 'Add Customer'
        //   }
        // },
        {
          path: 'createinvoice',
          name: 'createinvoice',
          component: CreateInvoice,
          meta: {
            requiresAuth: true,
            title: 'Invoice'
          }
        },
        {
          path: 'create-purchase-order',
          name: 'create-purchase-order',
          component: CreateInvoice,
          meta: {
            requiresAuth: true,
            title: 'Purchase Order'
          }
        },
        {
          path: 'create-quotation',
          name: 'create-quotation',
          component: CreateInvoice,
          meta: {
            requiresAuth: true,
            title: 'Quotation'
          }
        },
        {
          path: 'cash-flow',
          name: 'cash-flow',
          component: CashFlow,
          meta: {
            requiresAuth: true,
            title: 'Cash Flow'
          }
        },
        {
          path: 'create-labels',
          name: 'create-labels',
          component: CreateBarcode,
          meta: {
            requiresAuth: true,
            title: 'Create Labels'
          }
        },
        {
          path: 'kot',
          name: 'kot',
          component: KOT,
          meta: {
            requiresAuth: true,
            title: 'Create KOT'
          }
        },
        {
          path: 'kot/:id',
          name: 'kotedit',
          component: KOT,
          meta: {
            requiresAuth: true,
            title: 'Update KOT'
          }
        },
        {
          path: 'job-notes',
          name: 'jobNotes',
          component: JobNotes,
          meta: {
            requiresAuth: true,
            title: 'Job Notes'
          }
        },
        {
          path: 'order-processing',
          name: 'orderProcessing',
          component: JobNotes,
          meta: {
            requiresAuth: true,
            title: 'Order Processing'
          }
        },
        {
          path: 'invoicelist',
          name: 'invoicelist',
          component: InvoiceList,
          meta: {
            requiresAuth: true,
            title: 'Invoice List'
          }
        },
        {
          path: 'purchase-order-list',
          name: 'purchase-order-list',
          component: PurchaseOrders,
          meta: {
            requiresAuth: true,
            title: 'Purchase Order List'
          }
        },
        {
          path: 'quotation-list',
          name: 'quotation-list',
          component: Quotations,
          meta: {
            requiresAuth: true,
            title: 'Quotations List'
          }
        },
        {
          path: 'cash-flow-history',
          name: 'cash-flow-history',
          component: CashFlowList,
          meta: {
            requiresAuth: true,
            title: 'Cash Flow History'
          }
        },
        {
          path: 'returns',
          name: 'returns',
          component: Returns,
          meta: {
            requiresAuth: true,
            title: 'Returns'
          }
        },
        {
          path: 'purchase-order-returns',
          name: 'purchase-order-returns',
          component: ReturnsGRN,
          meta: {
            requiresAuth: true,
            title: 'Purchase Order Returns'
          }
        },
        {
          path: 'suppliers',
          name: 'suppliers',
          component: Suppliers,
          meta: {
            requiresAuth: true,
            title: 'Suppliers'
          }
        },
        {
          path: 'expenses',
          name: 'expenses',
          component: Expenses,
          meta: {
            requiresAuth: true,
            title: 'Expenses'
          }
        },
        {
          path: 'expense-categories',
          name: 'expense-categories',
          component: ExpenseCategories,
          meta: {
            requiresAuth: true,
            title: 'Manage Expense Categories'
          }
        },
        {
          path: 'users',
          name: 'users',
          component: Users,
          meta: {
            requiresAuth: true,
            title: 'Users'
          }
        },
        {
          path: 'verify-user',
          name: 'verifyusers',
          component: VerifyUser,
          meta: {
            requiresAuth: false,
            title: 'User Verification'
          }
        },
        {
          path: 'managecategories',
          name: 'managecategories',
          component: ManageCategories,
          meta: {
            requiresAuth: true,
            title: 'Manage Categories'
          }
        },
        {
          path: 'analytics',
          name: 'analytics',
          component: Analytics,
          meta: {
            requiresAuth: true,
            title: 'Analytics'
          }
        },
        {
          path: 'store-locations',
          name: 'storelocations',
          component: StoreLocations,
          meta: {
            requiresAuth: true,
            title: 'Store Locations'
          }
        },
        {
          path: 'customers',
          name: 'customers',
          component: Customers,
          meta: {
            requiresAuth: true,
            title: 'All Customers'
          }
        },
        {
          path: 'categories/:cat/allProducts',
          name: 'allProducts',
          component: AllProducts,
          meta: {
            requiresAuth: true,
            title: 'Admin All Products'
          },
        },
        {
          path: 'offers',
          name: 'offers',
          component: Offers,
          meta: {
            requiresAuth: true,
            title: 'Admin Offers'
          }
        },
        {
          path: 'offers/alloffers',
          name: 'alloffers',
          component: AllOffers,
          meta: {
            requiresAuth: true,
            title: 'Admin All Offers'
          }
        },
        {
          path: 'items',
          name: 'items',
          component: Items,
          meta: {
            requiresAuth: true,
            title: 'Admin Items'
          }
        },
        {
          path: 'items/allitems',
          name: 'allitems',
          component: AllItems,
          meta: {
            requiresAuth: true,
            title: 'Admin All Items'
          }
        },
        {
          path: 'orders',
          name: 'orders',
          component: Orders,
          meta: {
            requiresAuth: true,
            title: 'Admin Orders'
          }
        },
        {
          path: 'myshopin',
          name: 'myshopin',
          component: MyShopin,
          meta: {
            requiresAuth: true,
            title: 'MY SHOPiN'
          }
        },
        {
          path: 'categories/:cat/addproducts',
          name: 'categories',
          component: Categories,
          meta: {
            requiresAuth: true,
            title: 'Admin Categories'
          },
        },
        {
          path: 'categories/computers&mobiles/:cat/addproducts',
          name: 'mobiles',
          component: Mobiles,
          meta: {
            requiresAuth: true,
            title: 'Admin Categories'
          },
        },
        {
          path: 'categories/vehicles/:cat/addproducts',
          name: 'vehicles',
          component: Vehicles,
          meta: {
            requiresAuth: true,
            title: 'Admin Categories'
          },
        },
        {
          path: 'categories/:cat/product/edit/:product_id',
          name: 'editcommonproduct',
          component: EditCommonProduct,
          meta: {
            requiresAuth: true,
            title: 'Admin  Edit Products'
          },
        },
        {
          path: 'categories/computers&mobiles/:cat/product/edit/:product_id',
          name: 'editmobiles',
          component: EditMobiles,
          meta: {
            requiresAuth: true,
            title: 'Admin  Edit Products'
          },
        },
        {
          path: 'categories/vehicles/:cat/product/edit/:product_id',
          name: 'editvehicles',
          component: EditVehicles,
          meta: {
            requiresAuth: true,
            title: 'Admin  Edit Products'
          },
        },
        {
          path: 'payment',
          name: 'payment',
          component: Payment,
          meta: {
            requiresAuth: true,
            title: 'Payment'
          }
        },

      ]
    },

    // {
    //   path: '/admin-services/',
    //   name: 'admin-services',
    //   component: AdminServices,
    //   // path: 'admin',
    //   // name: 'admin',
    //   // component: Sidebar,
    //   meta: {
    //     requiresAuth: true,
    //     title: 'Admin'
    //   },
    //   children: [
    //     // {
    //     //   path: 'sidebar',
    //     //   name: 'sidebar',
    //     //   component: Sidebar
    //     // },
    //     {
    //       path: 'dashboard',
    //       name: 'dashboard-services',
    //       component: DashboardServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin Dashboard'
    //       },
    //     },
    //     {
    //       path: 'adminhome',
    //       name: 'adminhome-services',
    //       component: AdminHomeServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin Home Page'
    //       },
    //     },
    //     {
    //       path: 'adminabout',
    //       name: 'adminabout-services',
    //       component: AdminAboutServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin About Page'
    //       },
    //     },
    //     {
    //       path: 'admincontact',
    //       name: 'admincontact-services',
    //       component: AdminContactServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin Contact Page'
    //       },
    //     },
    //     {
    //       path: 'services',
    //       name: 'services',
    //       component: Services,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin Services'
    //       }
    //     },
    //     {
    //       path: 'gallery',
    //       name: 'gallery',
    //       component: Gallery,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin Gallery'
    //       }
    //     },
    //     {
    //       path: 'services/allservices',
    //       name: 'allservices',
    //       component: AllServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'Admin All Services'
    //       }
    //     },

    //     {
    //       path: 'myshopin',
    //       name: 'myshopin-services',
    //       component: MyShopinServices,
    //       meta: {
    //         requiresAuth: true,
    //         title: 'MY SHOPiN'
    //       }
    //     },

    //   ]
    // },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  //check for requriedAuth
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!firebase.auth().currentUser) {
      //Go to Signin
      //console.log('user not')
      next({
        path: '/signin',
        query: {
          redirect: to.fullPath
        }
      });
    } else if (firebase.auth().currentUser.displayName == 'super admin' || firebase.auth().currentUser.displayName == 'editor') {
      next()
    } else if (firebase.auth().currentUser.displayName == 'shop owner') {

      //Proceed to route
      if (to.fullPath != '/admin-services' && to.fullPath != '/admin-services/dashboard'
        && to.fullPath != '/admin-services/admincontact' && to.fullPath != '/admin-services/adminhome'
        && to.fullPath != '/admin-services/adminabout' && to.fullPath != '/admin-services/services' && to.fullPath != '/admin-services/gallery'
        && to.fullPath != '/admin-services/myshopin' && to.fullPath != '/admin-services/services/allservices' && to.fullPath != '/myaccount'
        && to.fullPath != '/admin/items' && to.fullPath != '/admin/items/allitems') {
        //console.log('user else', firebase.auth().currentUser.displayName)
        // console.log('store.state.systemUser.isLogedIn', store.state.systemUser.isLogedIn, to, from)
        if (store.state.systemUser.isLogedIn && from.fullPath.includes('admin')) {
          //console.log('store.state', from.fullPath)

          //********* NO NEED these role check bcz cant access refresh to verify user page ******
          // if (store.state.systemUser.role === 'Cashier') {
          //   if (to.fullPath == '/admin/createinvoice' || to.fullPath == '/admin/invoicelist' ||
          //     to.fullPath == '/admin/returns' || to.fullPath == '/admin/createbarcode') {
          //     next()
          //   }
          // } else if (store.state.systemUser.role === 'Shop Manager') {
          //   if (to.fullPath != '/admin/store-locations' && to.fullPath != '/admin/setting'
          //     && to.fullPath != '/admin/users') {
          //     next()
          //   }
          // } else next();
          next();

        }
        if (store.state.systemUser.isLogedIn && !from.fullPath.includes('admin')) {
          if (to.path != '/admin/verify-user') {
            // console.log('redirect')
            next('/admin/verify-user');
          }
          if (to.path == '/admin/verify-user') {
            // console.log('redirect')
            next();
          }
        }
        if (!store.state.systemUser.isLogedIn ) {
          // if (to.fullPath != '/admin/verify-user') {
          //   return next()
          // }
          // console.log('!store.state', store.state, to.fullPath == '/admin/verify-user')
          if (to.path != '/admin/verify-user') {
            // console.log('redirect')
            next('/admin/verify-user');
          }
          if (to.path == '/admin/verify-user') {
            // console.log('redirect')
            next();
          }
        }

      }
      // if(to.fullPath == '/myaccount'){
      //   next();
      // }
    } else if (firebase.auth().currentUser.displayName == 'starterplan shop owner') {
      //Proceed to route
      if (
        // to.fullPath == '/admin' || to.fullPath == '/admin/dashboard'
        // || to.fullPath == '/admin/gallery' || to.fullPath == '/admin/orders'
        // || to.fullPath == '/admin/admincontact' || to.fullPath == '/admin/adminhome'
        // || to.fullPath == '/admin/gallery' || to.fullPath == '/admin/offers' || to.fullPath == '/admin/verify-user' || to.fullPath == '/admin/offers/alloffers' || to.fullPath == '/admin/items/allitems'
        // || to.fullPath == '/admin/myshopin' || to.fullPath == '/admin/payment' || to.fullPath == '/admin/setting'
        // || to.fullPath == '/admin/analytics' || to.fullPath == '/admin/managecategories'
        // || to.fullPath == '/admin/stock-summary' || to.fullPath == '/admin/createinvoice'
        // || to.fullPath == '/admin/invoicelist' || to.fullPath == '/admin/returns'
        // || to.fullPath == '/admin/users' || to.fullPath == '/admin/store-locations'
        // || to.name == 'allProducts' || to.name == 'categories' || to.name == 'editcommonproduct'

        // checking not allowed paths instead of above allowed paths

        to.fullPath !== '/admin/customers' || to.fullPath == '/admin/suppliers' || to.fullPath == '/admin/quotation-list'
        || to.fullPath == '/admin/create-quotation' || to.fullPath == '/admin/purchase-order-list' || to.fullPath == '/admin/create-purchase-order'
        || to.fullPath == '/admin/purchase-order-returns' || to.fullPath == '/admin/expenses'
        || to.fullPath == '/admin/expense-categories' || to.fullPath == '/admin/cash-flow-history' || to.fullPath == '/admin/cash-flow'
        ) {
        //console.log('user else', firebase.auth().currentUser.displayName)
        //console.log('user owner')stock-summary
        if (store.state.systemUser.isLogedIn) {
          next();
        }
        if (!store.state.systemUser.isLogedIn) {
          if (to.path != '/admin/verify-user') {
            // console.log('redirect')
            next('/admin/verify-user');
          }
          if (to.path == '/admin/verify-user') {
            // console.log('redirect')
            next();
          }
        }
      }
    } else if (firebase.auth().currentUser.displayName == 'page owner') {
      //Proceed to route
      if (to.fullPath == '/admin-services' || to.fullPath == '/admin-services/dashboard'
        || to.fullPath == '/admin-services/admincontact' || to.fullPath == '/admin-services/adminhome'
        || to.fullPath == '/admin-services/adminabout' || to.fullPath == '/admin-services/services' || to.fullPath == '/admin-services/gallery'
        || to.fullPath == '/admin-services/myshopin' || to.fullPath == '/admin-services/services/allservices') {
        //console.log('user else', firebase.auth().currentUser.displayName)
        //console.log('user owner')
        next();
      }
    } else if (firebase.auth().currentUser.displayName == null) {
      //Proceed to route
      if (to.fullPath == '/myaccount') {
        //console.log('user else', firebase.auth().currentUser.displayName)
        //console.log('user owner')
        next();
      }
    }
    // else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){
    //   //Proceed to route
    //   //console.log('user else', firebase.auth().currentUser.displayName)
    //   //console.log('user else', firebase.auth().currentUser.emailVerified)
    //   //console.log('user else', firebase.auth().currentUser)
    //   //console.log('user owner')
    //   next({
    //     path: '/verifyemail',
    //     query: {
    //       redirect: to.fullPath
    //     }
    //   });
    // }
    else {
      //console.log('user else', firebase.auth().currentUser)
      //console.log('user else', firebase.auth().currentUser.displayName)
      // next({
      //   path: '/myaccount',
      //   query: {
      //     redirect: to.fullPath
      //   }
      // });
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    if (firebase.auth().currentUser) {
      if (firebase.auth().currentUser.displayName == 'shop owner') {
        //console.log('user owner')
        next({
          path: '/admin/dashboard',
          query: {
            redirect: to.fullPath
          }
        })
      } else if (firebase.auth().currentUser.displayName == 'starterplan shop owner') {
        //console.log('user owner')
        next({
          path: '/admin/dashboard',
          query: {
            redirect: to.fullPath
          }
        })
      } else if (firebase.auth().currentUser.displayName == 'page owner') {
        //console.log('user owner')
        next({
          path: '/admin-services/dashboard',
          query: {
            redirect: to.fullPath
          }
        })
      } else if (firebase.auth().currentUser.displayName == null) {
        //console.log('user else', firebase.auth().currentUser.emailVerified)
        next({
          path: '/myaccount',
          query: {
            redirect: to.fullPath
          }
        })
      }
    } else {
      //Proceed to route
      //console.log('user not guest')
      next();
    }
  } else if (to.matched.some(record => record.name === 'regshop')) {
      if (firebase.auth().currentUser) {
        if (firebase.auth().currentUser.displayName == 'shop owner' || firebase.auth().currentUser.displayName == 'starterplan shop owner') {
          console.log('user owner')
          router.push("/admin")
        } else if (firebase.auth().currentUser.displayName == null) {
          //console.log('user else', firebase.auth().currentUser.emailVerified)
          router.push("/myaccount")

        } else { next() }
      } else { next() }
    } else {
    //Proceed to route
    //console.log('user is')
    next()
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js